import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RenterLayoutComponent } from "./renter-layout/renter-layout.component";
import { RouterModule, Routes } from "@angular/router";
import { LayoutModule } from "@rubbl-layout";
import { TablesModule } from "@rubbl-tables";
import { SharedModule } from "app/shared/shared.module";
import { RenterInsuranceComponent } from "./renter-insurance/renter-insurance.component";
import { ManageSharedModule } from "../manage-shared/manage-shared.module";
import { RenterTaxComponent } from "./renter-tax/renter-tax.component";
import { RenterVerificationComponent } from "./renter-verification/renter-verification.component";

const routes: Routes = [
  {
    path: "",
    component: RenterLayoutComponent,
    children: [
      {
        path: "dashboard",
        loadChildren: () => import("./renter-dashboard/renter-dashboard.module").then(m => m.RenterDashboardModule),
      },
      {
        path: "rentals",
        loadChildren: () => import("./renter-rentals/renter-rentals.module").then(m => m.RenterRentalsModule),
      },
      {
        path: "verification",
        component: RenterVerificationComponent,
      },
      {
        path: "billing",
        loadChildren: () => import("./renter-billing/renter-billing.module").then(m => m.RenterBillingModule),
      },
      {
        path: "insurance",
        component: RenterInsuranceComponent,
      },
      {
        path: "tax",
        component: RenterTaxComponent,
      },
      {
        path: "",
        redirectTo: "dashboard",
      },
    ],
  },
];

@NgModule({
  declarations: [RenterLayoutComponent, RenterInsuranceComponent, RenterTaxComponent, RenterVerificationComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes), ManageSharedModule, LayoutModule, TablesModule],
})
export class RenterModule {}
